/** Chosen portraits are cosmetic and never depend on a secret role. */
export function PlayerAvatar({ seat = 0, winner = false }: { seat?: number; winner?: boolean }) {
  const index = ((seat % 10) + 10) % 10;
  const x = (index % 5) * 100;
  const y = Math.floor(index / 5) * 100;
  return (
    <svg
      className="crew-avatar"
      data-avatar-index={index}
      viewBox={winner ? "0 0 100 110" : "0 10 100 100"}
      aria-hidden="true"
    >
      <svg
        x="0"
        y="10"
        width="100"
        height="100"
        viewBox={index === 6 ? "0 0 100 100" : `${x} ${y} 100 100`}
        overflow="hidden"
      >
        <image
          href={index === 6 ? "/assets/avatars/moss-miner.webp" : "/assets/avatars/dwarf-portraits.webp"}
          width={index === 6 ? 100 : 500}
          height={index === 6 ? 100 : 200}
          preserveAspectRatio="none"
        />
      </svg>
      {winner ? (
        <path
          d="M30 18 24 3 39 10 50 0 61 10 76 3 70 18Z"
          fill="#f5cc70"
          stroke="#705220"
          strokeWidth="1.5"
        />
      ) : null}
    </svg>
  );
}
export function GoldNugget() {
  return (
    <svg className="gold-nugget" viewBox="0 0 40 40" aria-hidden="true">
      <path d="m7 12 17-7 11 13-7 17-21-5-4-12Z" fill="#efbf58" stroke="#b28733" strokeWidth="2" />
      <path d="m7 12 13 9 15-3M20 21l8 14" fill="none" stroke="#9e7126" strokeWidth="2" />
      <path d="m9 12 14-5 5 7-9 4Z" fill="#ffe3a0" />
    </svg>
  );
}
